import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import {
  NEW_AUDIO_STATUS,
  PUNCTUATION_REGEX,
} from '@src/constants/voiceCloning';
import { Warning } from '@mui/icons-material';
import { StyledRecordingContent } from './index.style';
import CheckAudioQuality from './CheckAudioQuality';

const RecordingContent = ({
  audios,
  sentences,
  currentIndex,
  loadingUpdateAudio,
  isRecording,
  audioDurationFail,
}) => {
  const conditionShowQuality =
    audios[currentIndex]?.audioLink &&
    !loadingUpdateAudio &&
    !isRecording &&
    !audioDurationFail &&
    audios[currentIndex]?.status !== NEW_AUDIO_STATUS.FAILED;

  const conditionShowNsws = sentences[currentIndex]?.nsws.length > 0;

  const conditionShowNote =
    audios[currentIndex]?.note &&
    ![NEW_AUDIO_STATUS.PASSED, NEW_AUDIO_STATUS.GOOD].includes(
      audios[currentIndex]?.status,
    );

  const Sentence = ({ sentence }) => {
    const words = sentence?.originalText.split(' ');

    const boxes = words?.map((word) => {
      let punctuation = '';
      let currentWord = word;
      // Extract punctuation if it exists
      if (PUNCTUATION_REGEX.test(word)) {
        punctuation = word.slice(-1);
        currentWord = word.slice(0, -1);
      }

      const isBoxWord = sentence?.nsws?.some(
        (nsw) => nsw.originalText === currentWord,
      );
      const isPunctuationBoxWord = sentence?.nsws?.some(
        (nsw) => nsw.originalText === punctuation,
      );

      return (
        <Box display="inline">
          <Box component="span" className={isBoxWord ? 'box-word' : ''}>
            {currentWord}
          </Box>
          {punctuation && (
            <Box
              component="span"
              className={isPunctuationBoxWord ? 'box-word' : ''}
            >
              {punctuation}
            </Box>
          )}{' '}
        </Box>
      );
    });
    return <Box className="sentence">{boxes}</Box>;
  };

  const NSWWord = ({ nsws }) => (
    <Box className="nsws">
      {nsws?.map((nsw) => (
        <Box className="nsws-word" key={nsw}>
          <Typography className="original">{nsw.originalText}</Typography>
          <Typography className="normalized">{nsw.normalizedText}</Typography>
        </Box>
      ))}
    </Box>
  );

  const ErrorNote = ({ note }) => (
    <Box className="note">
      <Warning className="note-icon" />
      <Typography className="note-content">{note}</Typography>
    </Box>
  );

  return (
    <StyledRecordingContent>
      <Sentence sentence={sentences[currentIndex]} />
      <Divider orientation="vertical" flexItem className="divider" />
      {conditionShowNsws && <NSWWord nsws={sentences[currentIndex]?.nsws} />}
      {conditionShowQuality && (
        <CheckAudioQuality
          qualityStates={audios[currentIndex].quality}
          conditionShowNote={conditionShowNote}
          audio={audios[currentIndex]}
        />
      )}
      {conditionShowNote && <ErrorNote note={audios[currentIndex]?.note} />}
    </StyledRecordingContent>
  );
};

export default RecordingContent;
